import { render, staticRenderFns } from "./ConciergesForm.vue?vue&type=template&id=20d3fa4e&scoped=true"
import script from "./ConciergesForm.vue?vue&type=script&lang=js"
export * from "./ConciergesForm.vue?vue&type=script&lang=js"
import style0 from "./ConciergesForm.vue?vue&type=style&index=0&id=20d3fa4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d3fa4e",
  null
  
)

export default component.exports